import { render, staticRenderFns } from "./PlanoSafra.vue?vue&type=template&id=6638f5b2"
import script from "./PlanoSafra.vue?vue&type=script&lang=js"
export * from "./PlanoSafra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports